import { Box, Tab, Tabs } from "@mui/material";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import {
  CONTRACTOR_PORTAL_NAV_ITEMS,
  isContractorPortalNavSelected,
} from "./contractorPortalNav";
import {
  ContractorPortalProvider,
  useContractorPortal,
} from "./ContractorPortalContext";

const PRIMARY = "#005B8F";

/**
 * Thin shell: horizontal section tabs only.
 * Uses the main SLN app chrome — no nested sidebar / duplicate portal title.
 */
const ContractorPortalLayoutInner = () => {
  const location = useLocation();
  useContractorPortal();

  const activeId =
    CONTRACTOR_PORTAL_NAV_ITEMS.find((item) =>
      isContractorPortalNavSelected(item, location.pathname)
    )?.id || false;

  return (
    <Box dir="rtl" data-testid="contractor-portal-layout" sx={{ width: "100%" }}>
      <Box
        component="nav"
        data-testid="contractor-portal-nav"
        sx={{
          mb: 2,
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          borderRadius: 1,
          px: 0.5,
        }}
      >
        <Tabs
          value={activeId}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          textColor="primary"
          indicatorColor="primary"
          sx={{
            minHeight: 44,
            "& .MuiTabs-indicator": { bgcolor: PRIMARY, height: 3 },
            "& .MuiTab-root": {
              minHeight: 44,
              textTransform: "none",
              fontWeight: 700,
              color: "text.secondary",
              px: { xs: 1.5, md: 2 },
            },
            "& .Mui-selected": { color: `${PRIMARY} !important` },
          }}
        >
          {CONTRACTOR_PORTAL_NAV_ITEMS.map((item) => (
            <Tab
              key={item.id}
              value={item.id}
              label={item.labelFa}
              component={RouterLink}
              to={item.path}
              data-testid={`contractor-portal-nav-${item.id}`}
            />
          ))}
        </Tabs>
      </Box>

      <Box component="main" data-testid="contractor-portal-content">
        <Outlet />
      </Box>
    </Box>
  );
};

const ContractorPortalLayout = () => (
  <ContractorPortalProvider>
    <ContractorPortalLayoutInner />
  </ContractorPortalProvider>
);

export default ContractorPortalLayout;
